/**
 *
 * AddDivisionModal
 *
 */

import React from "react"
import PropTypes from "prop-types"
// import styled from 'styled-components';
import { split, sortBy, reverse } from "lodash"
import { Select, Input } from "antd"
import "./index.less"
import ModalCustom from "../ModalCustom"

const { Option } = Select
class AddDivisionModal extends React.Component {
  constructor() {
    super()
    this.state = {
      divisionNoParents: [],
      subdivisions: [],
      reversed: false,
    }
  }


  componentDidUpdate(newProps) {
    if (newProps.reset != this.props.reset && this.props.reset == true) {
      this.props.changeName("")
      this.props.resetModal()
    }
    if (newProps.divisionNoParents != this.props.divisionNoParents) {
      const newArray = this.props.divisionNoParents
      this.setState({ divisionNoParents: newArray })
    }

    if (newProps.selectedDivisions != this.props.selectedDivisions) {
      const { divisionNoParents } = this.props
      const { selectedDivisions } = this.props

      let filteredArray = divisionNoParents.filter((division) => {
        return (
          selectedDivisions.filter((selected) => {
            return selected == division.id_division
          }).length == 0
        )
      })

      filteredArray = sortBy(filteredArray, "name")

      let i
      let j
      let subdivisions = []
      const { length } = divisionNoParents
      const lengthSelected = selectedDivisions.length

      for (i = 0; i < length; i++) {
        for (j = 0; j < lengthSelected; j++) {
          if (divisionNoParents[i].id_division == selectedDivisions[j]) {
            subdivisions.push(divisionNoParents[i])
          }
        }
      }

      if (this.state.reversed) {
        subdivisions = sortBy(subdivisions, "name")
        subdivisions = reverse(subdivisions)
      } else {
        subdivisions = sortBy(subdivisions, "name")
      }

      this.setState({ divisionNoParents: filteredArray, subdivisions })
    }
  }

  reverseArray = () => {
    let { subdivisions } = this.state

    subdivisions = reverse(subdivisions)

    this.setState({ subdivisions })
  }

  render() {
    const { props } = this
    const { state } = this
    return (
      <div className="divisionModal">
        <ModalCustom
          width={458}
          className="modalAddSubdivision"
          onCancel={props.onCancel}
          title="Crear división"
          model="División"
          closable={false}
          modalOpen={props.visible}
          margin="0"
          onOk={props.onOk}
          textAlign="left"
          showFooter
          isLoadingButton={props.isLoadingCreate}
          disabledButton={!this.props.name.length}>
          <div className="editModal">
            <p style={{ fontSize: 13, color: "#555155" }}>
              Ingresa el <strong style={{ fontWeight: 600 }}>nombre</strong> de
              la división que quieres crear:
            </p>
            <Input
              placeholder="Ejemplo: Marketing"
              name="division"
              value={this.props.name}
              maxLength={150}
              disabled={this.props.isLoadingCreate}
              loading={this.props.isLoadingCreate}
              onKeyPress={(e) => {
                if (e.key === "Enter") props.onOk()
              }}
              onChange={(event) => {
                /* let textArr = split(e.target.value, ' ');
                textArr = textArr.map((item, index) => {
                  const newWord = item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()
                  if (['De', 'La', 'Del', 'O', 'Y', 'El', 'Los', 'Las', 'San', 'Di', 'Da', 'A'].includes(newWord) && index !== 0) {
                    return newWord.toLowerCase();
                  }
                  return newWord
                }) */
                this.props.changeName(event.target.value)
              }}
              style={{ width: "72%" }}
            />
            <p style={{ fontSize: 13, color: "#555155", marginTop: "1rem" }}>
              Selecciona la{" "}
              <span style={{ fontWeight: 600 }}>división superior</span>. Esta
              se encontrará por encima de la división creada en el organigrama
              de la organización:
            </p>
            <Select
              showSearch
              style={{ width: "72%", alignSelf: "center" }}
              placeholder="Seleccionar división superior"
              optionFilterProp="children"
              allowClear
              value={this.props.id_parent}
              disabled={this.props.isLoadingCreate}
              loading={this.props.isLoadingCreate}
              onChange={(e) => {
                this.props.selectParentDivision(e)
              }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }>
              {props.divisionsSimple.map((item, index) => {
                return (
                  <Option key={index} value={item.id_division}>
                    {item.division}
                  </Option>
                )
              })}
            </Select>
          </div>
        </ModalCustom>
      </div>
    )
  }
}


AddDivisionModal.propTypes = {}

export default AddDivisionModal

